import React from "react";
import dayjs from "dayjs";

function MessageA4(props) {

  const messageContainerClassName = () => {
    return props.config.autoFullScreen ? "s360-message-cotainer-received-fs" : "s360-message-cotainer-received";
  }

  const messageBoxStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA4Box
  }

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA4Time
  }

  const text =props.entry.text;
  return (
    <div className={messageContainerClassName()}>
      <div className="s360-message-box-received-A4" style={messageBoxStyle()}>
        <div dangerouslySetInnerHTML={{ __html:text }}></div>
        <br/>
      </div>
      {props.isLastEntry && props.sentTimestamp&& <div className="s360-message-time-received" style={messageTimeStyle()}>{dayjs.unix(Math.trunc(props.sentTimestamp/1000)).format("DD MMM h:mm a")}</div>}
    </div>
  );
}

export default MessageA4;
